import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useStyles } from './style';


const NotFound = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <div className={classes.root}>
      <Grid container justifyContent="center" spacing={4}>
        <Grid item lg={6} xs={12}>
          <div className={classes.content}>
            <img alt="Under development" className={classes.image} src="./images/img404.svg" />
            <Typography className={classes.title} variant="h2">
              متاسفیم! اما صفحه مورد نظرتان را پیدا نکردیم!
            </Typography>
            <Typography className={classes.subTitle} variant="subtitle2">
              پیشنهاد می‌کنیم به
              <a onClick={() => navigate(-1)}> صفحه قبل </a>
              برگردید یا
              <a onClick={() => navigate('/')}> داشبورد </a>
              را مشاهده کنید
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default NotFound;
